<template>
  <v-app-bar v-if="false">
    <span class="title ml-3 mr-5">
      {{ $t('app.name') }}
    </span>
  </v-app-bar>
</template>
<script>
import { mapState } from 'vuex'

export default {
  name: 'LayoutDefaultHeader',
  computed: {
    ...mapState('ui', ['navDrawer'])
  }
}
</script>
